var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogotype(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 258,
    viewBox: "0 0 858 258",
    width: 858,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49 94v45.1c0 13.3 11.7 24.1 26 24.1s26-10.8 26-24.1v-45.1h-10.4v45.1c0 8.3-6.8 14.7-15.6 14.7s-15.6-6.5-15.6-14.7v-45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.2 117.1 45.7 45.6v-68.7h-10.4v45.4l-45.8-45.6v68.5h10.4v-45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.3 162.3h10.4v-68.3h-10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.9 149c3.4 8.6 12.5 14.3 23.1 14.3 13.2 0 22.4-8.4 22.4-20.5 0-12.4-9.8-16.7-18.5-20.6-6.7-3-13-5.8-13-12 0-4.9 4-8.5 9.5-8.5 4.6 0 8 2.4 9.5 6.6l9.2-4c-3.1-6.9-10.4-11.3-19-11.3-11.5 0-19.5 7.2-19.5 17.5 0 11 8.8 14.9 17.4 18.7 7.2 3.2 14 6.2 14 13.4 0 6.6-5.2 11.3-12.3 11.3-6.2 0-11.2-3.4-13.3-8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.1 162.3h10.4v-58.9h19.4v-9.4h-49.4v9.4h19.5v58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.3 162.3h45v-9.4h-34.5v-20.1h30.6v-9.4h-30.6v-20.1h34.5v-9.4h-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.2 162.3h39v-9.4h-28.6v-58.9h-10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m592.6 162.3h39v-9.4h-28.6v-58.9h-10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m796.6 162.3h11.9l-16.9-27.1 1.5-.5c8.7-3.1 14.1-10.6 14.1-19.7 0-12-9.7-21-22.7-21h-27.1v68.3h10.4v-58.9h15.7c8 0 13.2 4.5 13.2 11.6 0 7.2-5.1 11.7-13.2 11.7h-8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m671.8 140.5-10.4 21.8h11.8l9.6-21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m694 93.7-18.2 38.2h10.7l7.5-16.9 20.7 47.3h11.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotype);
export default __webpack_public_path__ + "static/media/Logotype.8e36a1f899cbf5c3439e333151190504.svg";
export { ForwardRef as ReactComponent };